import React from 'react';
import { localize } from 'core/localization';
import { Figure } from './Figure.styled';

export const StartOver = () => (
  <Figure
    width="260px"
    height="127px"
    viewBox="0 0 260 127"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    arialabel={`${localize('[start over]')}`}
  >
    <title>22A00D1A-3369-4516-81AB-CC2786BABD7B</title>
    <desc>Created with sketchtool.</desc>
    <defs>
      <path id="dvpdj70tgb" d="M12.88 0h52.628c2.761 0 5 2.239 5 5v85c0 2.761-2.239 5-5 5H5c-2.761 0-5-2.239-5-5V12.96L12.88 0z"/>
      <path id="uv596r90gc" d="M91 22c2.761 0 5 2.239 5 5v44c0 2.761-2.239 5-5 5H47c-2.761 0-5-2.239-5-5l-.001-10H33l8.999-9.999L42 27c0-2.761 2.239-5 5-5h44z"/>
      <filter id="98ia7jy47a" width="100%" height="100%" x="0%" y="0%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceGraphic"/>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-590 -164) translate(590 164)">
          <g fill="#363E4E" opacity=".02">
            <g>
              <path
                d="M74.48.423H20.984s-9.378 1.012-9.378 8.467c0 7.454 9.378 8.466 9.378 8.466l31.828.06s7.447 1.452 7.447
                7.983c0 6.53-7.447 8.466-7.447 8.466H36.368s-13.348.815-13.348 8.89c0 8.074 13.348 9.312 13.348 9.312H9.479S0
                53.7 0 60.473C0 67.246 9.48 69 9.48 69h207.865s11.703-1.33
                11.703-8.527c0-7.196-11.703-8.406-11.703-8.406H197.02s-11.868-.707-12.08-8.042c-.211-7.336 12.08-8.709
                12.08-8.709l23.586-.816s12.31 1.814 12.31-8.376-11.325-8.768-11.325-8.768l28.253.06S260 16.806 260 8.89C260
                .973 249.844 0 249.844 0L74.479.423z"
                filter="url(#98ia7jy47a)"
                transform="translate(0 37)"
              />
            </g>
          </g>
          <g>
            <g transform="translate(88)">
              <use fill="#FFF" xlinkHref="#dvpdj70tgb"/>
              <use fill="#FC794B" fillOpacity=".2" xlinkHref="#dvpdj70tgb"/>
            </g>
            <path
              fill="#FBCCBC"
              d="M8 24H33V28H8zM8 34H33V38H8zM8 54H33V58H8zM8 44H33V48H8zM8 64H33V68H8zM8 74H33V78H8z"
              transform="translate(88)"
            />
            <g transform="translate(88)">
              <use fill="#FFF" xlinkHref="#uv596r90gc"/>
              <use fill="#FC794B" fillOpacity=".9" xlinkHref="#uv596r90gc"/>
              <use stroke="#FFF" xlinkHref="#uv596r90gc"/>
              <use stroke="#FFF" strokeWidth="3" xlinkHref="#uv596r90gc"/>
            </g>
            <path
              fill="#FFF"
              d="M69.125 46.77c5.592 0 10.125 4.533 10.125 10.125v6.885H59v-6.885c0-5.592 4.533-10.125 10.125-10.125zm0-13.77c3.802 0 6.885 3.083 6.885 6.885 0 3.802-3.083
              6.885-6.885 6.885-3.802 0-6.885-3.083-6.885-6.885 0-3.802 3.083-6.885 6.885-6.885z"
              transform="translate(88)"
            />
            <path
              fill="#EE6C3F"
              fillOpacity=".2"
              d="M12.881 12.96L0 12.96 12.881 0z"
              transform="translate(88)"
            />
          </g>
          <ellipse cx="131" cy="123" fill="#F5F7FB" rx="43" ry="4" />
          <circle cx="165.5" cy="59.5" r="5.5" fill="#FFF" stroke="#FD875D" strokeWidth="2" />
          <path
            fill="#FC865D"
            fillRule="nonzero"
            d="M165.952 58.064l.984.984-2.46 2.46-.984-.984
            2.46-2.46zm1.967-.492c-.147.099-.59-.344-.491-.491-.361-.197-.69-.033-.984.491l.984.984c.524-.295.688-.623.491-.984zM163 62h.984l-.984-.984V62z"
          />
        </g>
      </g>
    </g>
  </Figure>
);

export default StartOver;
